import { writable } from "svelte/store";

// Redirects reload the page, so the sign-in dialog that initiated them is gone.
// Keep failure presentation outside the dialog, including when analytics is off.
export const authRedirectNotice = writable<string | null>(null);

export function reportAuthRedirectFailure(guestUpgrade = false) {
  authRedirectNotice.set(
    guestUpgrade
      ? "We couldn't save your progress to that account. Your guest progress is still available. Try saving again, or use email."
      : "Sign-in could not be completed. Please try signing in again, or choose “Use email instead”."
  );
}
